import cs from 'classnames'
import React from 'react'
import { ImageSquareCropper } from '../../routes/groups/components/entity/header'
import { Image } from '../../ui/Img'

export const PublicGroupWrapper = props => {
  const profile = props?.resource?.target

  const standardHeader =
    !profile?.theme ||
    profile?.theme?.display_logo ||
    profile?.theme?.display_title === 'always'

  const url = profile?.background_image_url ?? profile?.image_url

  const styles = {
    header: {
      inline:
        !profile?.theme || profile?.theme?.display_logo
          ? {
              backgroundImage: `url('${url.replace(
                '{image_size}',
                'profile-background'
              )}')`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              paddingBottom: 0,
            }
          : {
              backgroundColor: profile.theme?.brand_color ?? '#09336a',
              backgroundImage: profile.theme?.brand_color ? 'none' : undefined,
            },
      classes: cs(
        'fs-unmask',
        'dark-background',
        'profile-header',
        'profile-header--group',
        'profile-header--full',
        {
          'profile-header--standard': standardHeader,
          'profile-header--banner': !standardHeader,
        }
      ),
    },
    pageContainer: cs('page__container profile-header__inner', {
      'profile-header__inner--has-sibling': true,
    }),
  }

  return (
    <div className="search-bar__parent-wrapper">
      {profile.has_banner_image ? (
        <div
          className="profile-header-banner"
          style={{
            backgroundColor:
              profile.theme?.header_background_color || 'transparent',
          }}
        >
          <div className="page__container">
            <Image
              url={profile.banner_image_url}
              size={'profile-background-nofx'}
            />
          </div>
        </div>
      ) : null}
      <header className={styles.header.classes} style={styles.header.inline}>
        <div
          className={styles.pageContainer}
          style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: 0,
            border: 'none',
          }}
        >
          <div
            className="profile-basic"
            style={{ flexGrow: 2, paddingRight: 0 }}
          >
            {!profile?.theme || profile?.theme?.display_logo ? (
              <div className="media media--large" style={{ minHeight: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <ImageSquareCropper
                    width={60}
                    height={60}
                    style={{ marginRight: 20 }}
                  >
                    <Image
                      url={profile.image_url}
                      shape={'square'}
                      size={'m-group-large' /* scaled down in css */}
                      className="media__img profile__img profile__img--group"
                      inlineStyle={{ cursor: 'pointer' }}
                    />
                  </ImageSquareCropper>
                  <h1 className={cs({ profile__name: true, mega: true })}>
                    <a style={{ color: 'white' }}>{profile.title}</a>
                  </h1>
                </div>
              </div>
            ) : (
              <div className="profile-header__detail">
                <h1 className={cs({ profile__name: true, mega: true })}>
                  <a style={{ color: 'white' }}>{profile.title}</a>
                </h1>
              </div>
            )}
          </div>
        </div>
      </header>

      {props.children ? props.children : null}
    </div>
  )
}
